













import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { GPageBase } from '@/mixins';
import { GEnum } from '@/constants/enum.defination';
import { activityModule } from '@/store/modules/entities/activity.module';
import { Activity, UpdateActivityParam } from '@/models/activity/activity';

@Component({
  name: 'GExamListTitleInput',
  computed: {},
  methods: {},
})
export default class GExamListTitleInput extends Mixins(GPageBase) {
  tempName: string = ''; // タイトル編集時の一時保存用(Enter押下時にリセットされる)

  @Prop() activity: Activity;
  @Prop() isDisable: boolean;

  mounted() {}

  handleFocus() {
    this.tempName = this.activity.activityName;
  }

  handleEditTitleBlur(activity: Activity) {
    if (activity.activityName === '') {
      activity.activityName = this.tempName;
      return;
    } else if (activity.activityName === this.tempName) {
      return;
    }
    const beforeTitle: string = this.tempName;

    this.handleUpdateTitle(this.activity);
  }

  // アクティビティ名の更新
  handleUpdateTitle(act: Activity) {
    const updateActivityParam: UpdateActivityParam = {
      ID: act.activityID,
      activityName: act.activityName,
    };
    this.loadingPage(
      () => {
        activityModule.updateActivity(updateActivityParam);
      },
      () => {
        this.showNotice(GEnum.MessageType.Success, 'アクティビティ名変更', `編集前：${this.tempName}<br/>編集後：${act.activityName}`);
      },
      500
    );
  }
}
